export default "__VITE_ASSET__2c1bac98__"